export default "__VITE_ASSET__27efebc5__"